import React from 'react'
import { Link } from "react-router-dom"; 
import { Typography, Card, CardContent, CardMedia } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import { demoThumbnailUrl, demoVideoUrl, demoVideoTitle, demoChannelUrl, demoChannelTitle } from "../utils/constants";

const SlideVideoCard = ({ video: { id: { videoId }, snippet } }) => (
    <CardMedia image={snippet?.thumbnails?.high?.url || demoThumbnailUrl} alt={snippet?.title} 
            sx={{ borderRadius:"10px", backgroundSize:"contain",width: { xs: '100%', sm: '150px'}, height: "100px" }} 
        />
);

export default SlideVideoCard